import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export default function SocialProofSection() {
  const { data } = useQuery({
    queryKey: ["landing-stats"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_landing_page_stats");
      if (error) throw error;
      return data as { tips_submitted: number; players: number; leagues_created: number };
    },
  });

  const stats = [
    { value: data?.tips_submitted, label: "Tips Submitted" },
    { value: data?.players, label: "Players" },
    { value: data?.leagues_created, label: "Leagues Created" },
  ];

  return (
    <section className="relative px-6">
      <div className="mx-auto max-w-2xl py-8">
        <div className="grid grid-cols-3 gap-4 text-center">
          {stats.map((s) => (
            <div key={s.label}>
              <span className="block text-2xl font-black text-primary sm:text-4xl">
                {data ? s.value : "—"}
              </span>
              <span className="mt-1 block text-[9px] font-semibold uppercase tracking-widest text-muted-foreground sm:text-xs">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
